import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setLocale, fetchMessages, fetchMessagesSuccess, fetchMessagesFailed } from "./index";
import { LABELS_API } from "../../apiUrl";
import { createRequest } from "../../utility";

const setLocaleWorker = (action, listenerApi) => {
  const locale = action.payload;
  window.document.getElementsByTagName("html")[0]?.setAttribute("lang", locale.slice(0, 2));
  try {
    const messages = new Map(JSON.parse(listenerApi.getState().language.messages)).get(locale);
    if (messages == null) listenerApi.dispatch(fetchMessages(locale));
  } catch (e) {
    console.error("Errore durante il set della lingua:", e);
  }
};

const fetchMessagesWorker = (action, listenerApi) => {
  const locale = action.payload;
  createRequest(LABELS_API.method, LABELS_API.baseUrl, LABELS_API.apiUrl + "_" + locale.slice(0, 2) + ".json")
    .then((response) => {
      if (response.status === 200) listenerApi.dispatch(fetchMessagesSuccess({ locale: locale, messages: response.data }));
      else throw response.message;
    })
    .catch((e) => {
      console.error("Errore durante il caricamento del dizionario per la lingua", locale, ":", e);
      listenerApi.dispatch(fetchMessagesFailed());
    });
};

export const languageMiddleware = createListenerMiddleware();

languageMiddleware.startListening({
  actionCreator: setLocale,
  effect: async (action, listenerApi) => setLocaleWorker(action, listenerApi),
});

languageMiddleware.startListening({
  actionCreator: fetchMessages,
  effect: async (action, listenerApi) => fetchMessagesWorker(action, listenerApi),
});
